import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './components/homepage/Home';
import GeneratingResults from "./components/homepage/GeneratingResults";
import Login from './components/login/Login';
import Signup from './components/signup/SignUp';
import ForgotPassword from './components/login/PasswordResetModal';
import "./custom.css";
import "./fonts.css";
import { ToastContainer, Bounce } from 'react-toastify';
import PrivateRoute from "./PrivateRoute";
import PrivacyPolicy from './components/privacypolicy/PrivacyPolicy';
import Reference from './components/references/Reference';
import DeleteContent from './components/DeleteAccount/DeleteContent';

function App() {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/ezGUIDE-references" element={<Reference />} />
          <Route path="/delete-account" element={<DeleteContent />} />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            path="/results"
            element={
              <PrivateRoute>
                <GeneratingResults />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router >
    </>
  );
}

export default App;